import React from 'react'
import { modalVisibility, ModalVisibilityProps, openModal } from 'sb-modal'

import ReviewTagsModalView from '../ReviewTagsModalView/ReviewTagsModalView'
import useReviewTagsModal from './util/useReviewTagsModal'


const ReviewTagsModal: React.FunctionComponent<Review.ReviewTagsModalProps & ModalVisibilityProps> = (props) => {
  const { step, stepCount, type, tags, isFetching, handleVote, handleSkip } = useReviewTagsModal(props)

  return (
    <ReviewTagsModalView
      {...{
        step,
        stepCount,
        type,
        tags,
        isFetching,
      }}
      onVote={handleVote}
      onSkip={handleSkip}
      onClose={handleSkip}
    />
  )
}


export const openReviewTagsModal = (props: Review.ReviewTagsModalProps) =>
  openModal<Review.ReviewTagsModalProps>('reviewTags', props)


export default modalVisibility('reviewTags', ReviewTagsModal)
